import request from '../helpers/request';

const updateRequestAddress = async (requestId, data) => {
  return await request.put(
    `/Request/set_address/${requestId}`,
    data,
    'Не удалось изменить адрес'
  );
};

export default updateRequestAddress;
